module.exports = __webpack_public_path__ + "static/media/kubernetes.07b339ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/PlaygroundSection/skills/kubernetes.jpg
// module id = 276
// module chunks = 0